export default "<div question-wrapper=\"presented\">\r\n    <div ng-if=\"!isVisible || isVisible()\" compile=\"presented.Text\"></div>\r\n</div>"